import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@mui/material/IconButton";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Fade from '@mui/material/Fade';

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

const ContinueCard = (props) => {
  const classes = useStyles();
  return (
    <Fade in={true} timeout={500}>
      <Box sx={{ display: "flex", justifyContent: "", mt: 2 }}>
        <Card
          className={classes.card}
          sx={{ boxShadow: "4px 4px 10px 0px #E5E5E5" }}
          onClick={props.press}
        >
          <CardContent sx={{ py: 1, height: "8rem" }}>
            {props.course && (
              <>
                <Typography
                  className={classes.ModuleNum}
                  sx={{ color: "primary.main", lineHeight: 1 }}
                >
                  {props.course.session.replaceAll("$","")}
                </Typography>
                {/* <Typography className={classes.ModuleName} sx={{ color: 'primary.main'}}>
                        Advanced Grammar Language...
                    </Typography> */}
                <Typography
                  className={classes.cardText}
                  color="primary.main"
                  sx={{ borderTop: 1, borderColor: "#D9D9D9", mt: 0.2 }}
                >
                  {props.course.module}
                </Typography>
              </>
            )}
            {props.bottomText && (
              <Typography className={classes.className}>
                {props.bottomText}
              </Typography>
            )}
          </CardContent>
          <CardActions sx={{ justifyContent: "flex-end", py: 0, pb: 1, pt: 1 }}>
            <IconButton
              aria-label="Go"
              size="small"
              sx={{
                borderRadius: "50%",
                backgroundColor: "#F5F5F5",
                color: "primary.main",
                padding: 0.5,
                "@media (min-width: 1636px)": { mt: 4 },
              }}
            >
              <NavigateNextIcon
                fontSize="inherit"
                sx={{ fontSize: "1.5rem" }}
              />
            </IconButton>
          </CardActions>
        </Card>
      </Box>
    </Fade>
  );
};

const useStyles = makeStyles({
  card: {
       background: "linear-gradient(135deg, rgba(180,227,145,1) 0%,rgba(97,196,25,1) 50%,rgba(180,227,145,1) 100%)",
    width: "9rem",
    shadowColor: "#000",
    boxShadow: "2rem",
    paddingTop: "1rem",
    cursor: "pointer",
    "@media (min-width: 1636px)": {
      width: "13rem",
      height: "15rem",
    },
  },
  ModuleNum: {
    fontSize: "0.77rem",
    textAlign: "center",
    fontWeight: "700",
    height: "3.3rem",
    overflow: "hidden",
    "@media (min-width: 1636px)": {
      fontSize: "1rem",
      height: "4.3rem",
    },
  },
  ModuleName: {
    fontSize: "0.6rem",
    textAlign: "center",
    fontWeight: "500",
    paddingBottom: 10,
    paddingTop: 5,
    "@media (min-width: 1636px)": {
      fontSize: "0.8rem",
    },
  },
  cardText: {
    fontSize: "0.9rem",
    textAlign: "center",
    fontWeight: "600",
    paddingTop: 10,
    "@media (min-width: 1636px)": {
      fontSize: "1.1rem",
    },
  },
  className: {
    borderRadius: 20,
    textAlign: "center",
    color: "#DB8829",
    fontSize: "0.9rem",
    fontWeight: "700",
    marginTop: 5,
    marginLeft: 10,
    marginRight: 10,
    backgroundColor: "#F5F7FF",
    "@media (min-width: 1636px)": {
      fontSize: "1.1rem",
    },
  },
});

export default ContinueCard;
